import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { spring } from "../theme/motion";

export default function Modal({ open, onClose, onDismiss, width = 520, children }) {
  // onDismiss fires for backdrop-click and Escape (the "casual" closes we may
  // want to guard). Falls back to onClose when not provided. The X / Cancel
  // buttons inside the modal call onClose directly and are never guarded.
  const dismiss = onDismiss || onClose;

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && dismiss?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, dismiss]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          key="crm-modal-root"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18, ease: "easeOut" }}
          className="fixed inset-0 z-[1100]"
        >
          <div
            onClick={dismiss}
            className="absolute inset-0 bg-black/45 backdrop-blur-[2px]"
          />
          <div className="absolute inset-0 flex items-start justify-center p-6 pointer-events-none">
            <motion.div
              initial={{ opacity: 0, y: 12, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 8, scale: 0.98, transition: { duration: 0.16, ease: "easeIn" } }}
              transition={spring.smooth}
              style={{ width, maxWidth: "calc(100vw - 32px)", marginTop: 80, boxShadow: "0 24px 64px rgba(0,0,0,0.24)" }}
              className="relative pointer-events-auto bg-[var(--color-bg-base)] border border-[var(--color-border-subtle)] rounded-xl overflow-hidden flex flex-col max-h-[calc(100vh-160px)]"
            >
              {children}
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
